import { useCallback, useEffect, useRef, useState } from "react";
import { register, unregister } from "register-service-worker";

export const useServiceWorker = (timeout: number) => {
  const [updateAvailable, setUpdateAvailable] = useState<boolean>(false);
  const registrationRef = useRef<ServiceWorkerRegistration>();

  useEffect(() => {
    const interval = (setInterval(() => {
      if (registrationRef.current) {
        registrationRef.current.update();
      }
    }, timeout) as unknown) as number;
    return () => clearInterval(interval);
  }, [timeout]);

  const onRegistered = (registration: ServiceWorkerRegistration) => {
    registrationRef.current = registration;
    registration.onupdatefound = () => {
      const installing = registration.installing;
      const active = registration.active;
      const waiting = registration.waiting;
      installing.onstatechange = () => installing.postMessage("skipWaiting");
      active.onstatechange = () => installing.postMessage("skipWaiting");
      waiting.onstatechange = () => installing.postMessage("skipWaiting");
    };
  };

  const onUpdate = (registration: ServiceWorkerRegistration) => {
    setUpdateAvailable(!!registration?.waiting);
  };

  const update = useCallback(() => {
    if (updateAvailable && registrationRef.current?.waiting) {
      registrationRef.current.waiting.postMessage("update");
    }
  }, [updateAvailable]);

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      register("/sw.js", {
        registered: onRegistered,
        updated: onUpdate
      });
    } else {
      unregister();
    }
  }, []);

  return { update, updateAvailable };
};
